import { Theme, ThemeProvider } from '@mui/material/styles'
import React from 'react'

import theme from './index.ts'

interface ThemeProviderProps {
  // TODO: implement light/dark themes via ThemeType
  // type?: ThemeType;
  theme: Theme
  children: React.ReactNode
}
function WayshrineThemeProvider(props: ThemeProviderProps) {
  return (
    // Recommended ThemeProvider configuration for using styles-components along side material-ui:
    // https://github.com/mui-org/material-ui/issues/10098#issuecomment-574162533
    <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
  )
}

export default WayshrineThemeProvider
